import {ServiceBase} from "../ServiceBase";
import {IAdminBannerService} from "./admin-banner-service.interface";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";

export interface AdminBannerSegmentations {
    IsFTD: boolean;
    PlayerRMStatus: number;
    IsPromotionPermitted: boolean;
    IsHybrid: boolean;
    IsAuthenticated: boolean;
    Serial: string;
    Cid: string;
    States: string;
}

export class AdminBannerService extends ServiceBase implements IAdminBannerService{
    constructor(services: IServiceFactoryExtended) {
        super(services);
        if(this.adminBannerEnabled) {
            const firstScript = this.services.configuration.servicesConfigs.Integration.adminBannerScript1;
            const secondScript = this.services.configuration.servicesConfigs.Integration.adminBannerScript2;
            this.services.sdk.loadScript(firstScript).catch(err => {
                this.services.logger.error(`Failed to load admin banner script: ${firstScript}`, err);
            });
            this.services.sdk.loadScript(secondScript).catch(err => {
                this.services.logger.error(`Failed to load admin banner script: ${secondScript}`, err);
            });
        }
    }

    public getSegmentationsForAdminBanner(): AdminBannerSegmentations {
        const userData = this.services.sdk.userData;
        return {
            IsFTD: userData.isFTD,
            PlayerRMStatus: userData.playerRMStatus,
            IsPromotionPermitted: userData.IsPromotionPermitted,
            IsHybrid: this.services.device.hybrid.isHybrid,
            IsAuthenticated: this.services.user.isAuthorized,
            Serial: this.services.marketing.getMarketingData().sr?.toString() || "",
            Cid: userData.cid?.toString() || '',
            // Todo - take the state according to webdata
            States: '',
        }
    }

    public getConfigForAdminBanner(bannerAdminPlaceholderId: string): any {
        return {
            placeholderId: bannerAdminPlaceholderId,
            deviceCode: this.services.device.os.isMobileOS ? "mobile": "desktop",
            languageCode: this.services.language.currentLanguage
        }
    }

    get adminBannerEnabled(): boolean {
        return this.services.configuration.data.adminBanner.enabled;
    }
}